import { Pipe, PipeTransform } from '@angular/core';
import { ProjectStatus } from '@nx-customer-apps/shared/enums';

@Pipe({ name: 'projectStatusStyles' })
export class ProjectStatusStylesPipe implements PipeTransform {
    transform(projectStatus: ProjectStatus): string {
        const styles = {
            [ProjectStatus.Design]: 'label-dark-grey',
            [ProjectStatus.PlanningDone]: 'label-yellow',
            [ProjectStatus.QuoteCreated]: 'label-blue',
            [ProjectStatus.OrderPlaced]: 'label-seledin',
            [ProjectStatus.Completed]: 'label-green',
            [ProjectStatus.Closed]: 'label-red',
            [ProjectStatus.Archived]: 'label-light-grey',
            [ProjectStatus.Migrated]: 'label-salmon',
            [ProjectStatus.MigratedClosed]: 'label-red',
            [ProjectStatus.New]: 'label-red'
        };
        return styles[projectStatus] || 'label-dark-grey';
    }
}
